<template>
	<div>
		<div v-if="showModal">
			<!-- <teleport to="#fiche-modal"> -->
			<!-- <transition name="modal"> -->
			<div class="modal-mask modal">
				<div
					class="modal-wrapper"
					@click="
						showModal = false;
						idprofile = '';
					"
				>
					<div class="modal-dialog modal-lg">
						<div class="modal-content" @click.stop>
							<div class="modal-header">
								<div class="col-lg-12 dynvibeTitleBox" style="padding-bottom: 10px; margin-bottom: 0px">
									<h5 class="modal-title" id="dynvibeGraphDetailsTitleAuthors">
										{{ modalTitle }}
										<button
											type="button"
											class="close"
											@click="
												showModal = false;
												idprofile = '';
											"
										>
											<span aria-hidden="true">
												<i class="icon-x"></i>
											</span>
										</button>
									</h5>
								</div>
							</div>
							<div class="modal-body" id="profiles-edit-body">
								<div class="row dynvibeModalRowForm">
									<div class="col-lg-2">
										<label for="dynvibeNewAuthorTwitter">Twitter</label>
									</div>
									<div class="col-lg-10">
										<input
											id="dynvibeNewAuthorTwitter"
											class="dynvibeInputText"
											name="dynvibeNewAuthorTwitter"
											data-provider="twitter"
											type="text"
											v-model="sources.twitter.username"
										/>
										<span
											class="dynvibeButtonIcon dynvibeNewAuthorRefreshSource fas fa-sync"
											@click="apiProfile('twitter', sources.twitter.username)"
										></span>
									</div>
								</div>
								<div class="row dynvibeModalRowForm">
									<div class="col-lg-2">
										<label for="dynvibeNewAuthorInstagram">Instagram</label>
									</div>
									<div class="col-lg-10">
										<input
											id="dynvibeNewAuthorInstagram"
											class="dynvibeInputText"
											name="dynvibeNewAuthorInstagram"
											data-provider="instagram"
											type="text"
											v-model="sources.instagram.username"
										/>
										<span
											class="dynvibeButtonIcon dynvibeNewAuthorRefreshSource fas fa-sync"
											@click="apiProfile('instagram', sources.instagram.username)"
										></span>
									</div>
								</div>
								<div class="row dynvibeModalRowForm">
									<div class="col-lg-2">
										<label for="dynvibeNewAuthorYoutube">Youtube</label>
									</div>
									<div class="col-lg-10">
										<input
											id="dynvibeNewAuthorYoutube"
											class="dynvibeInputText"
											name="dynvibeNewAuthorYoutube"
											data-provider="youtube"
											type="text"
											v-model="sources.youtube.username"
										/>
										<span
											class="dynvibeButtonIcon dynvibeNewAuthorRefreshSource fas fa-sync"
											@click="apiProfile('youtube', sources.youtube.username)"
										></span>
									</div>
								</div>
								<div class="row dynvibeModalRowForm">
									<div class="col-lg-2">
										<label for="dynvibeNewAuthorPinterest">Pinterest</label>
									</div>
									<div class="col-lg-10">
										<input
											id="dynvibeNewAuthorPinterest"
											class="dynvibeInputText"
											name="dynvibeNewAuthorPinterest"
											data-provider="pinterest"
											type="text"
											v-model="sources.pinterest.username"
										/>
										<span
											class="dynvibeButtonIcon dynvibeNewAuthorRefreshSource fas fa-sync"
											@click="apiProfile('pinterest', sources.pinterest.username)"
										></span>
									</div>
								</div>
								<div class="row dynvibeModalRowForm">
									<div class="col-lg-2">
										<label for="dynvibeNewAuthorName">Name *</label>
									</div>
									<div class="col-lg-10">
										<input
											id="dynvibeNewAuthorName"
											class="dynvibeInputText"
											name="dynvibeNewAuthorName"
											type="text"
											v-model="profile.profile_name"
										/>
									</div>
								</div>
								<div class="row dynvibeModalRowForm">
									<div class="col-lg-2">
										<label for="dynvibeNewAuthorBio">Biography</label>
									</div>
									<div class="col-lg-10">
										<textarea
											id="dynvibeNewAuthorBio"
											class="dynvibeInputText"
											name="dynvibeNewAuthorBio"
											type="text"
											style="width: 390px; height: 150px"
											v-model="profile.profile_bio"
										></textarea>
									</div>
								</div>
								<div class="row dynvibeModalRowForm">
									<div class="col-lg-2">
										<label for="dynvibeNewAuthorGender">Gender *</label>
									</div>
									<div class="col-lg-10">
										<select
											id="dynvibeNewAuthorGender"
											class="dynvibeSelect"
											name="dynvibeNewAuthorGender"
											v-model="profile.profile_gender"
										>
											<option value="unknown">Unknown</option>
											<option value="male">Male</option>
											<option value="female">Female</option>
										</select>
									</div>
								</div>
								<div class="row dynvibeModalRowForm">
									<div class="col-lg-2">
										<label>Age *</label>
									</div>
									<div class="col-lg-10">
										<select
											id="dynvibeNewAuthorAge"
											class="dynvibeSelect"
											name="dynvibeNewAuthorAge"
											v-model="profile.profile_age"
											@change="changeAuthorAge($event)"
										>
											<option v-for="val in authorAgeList" :key="val.id" :value="val.id">
												{{ val.value }}
											</option>
										</select>

										<select
											id="dynvibeNewAuthorYob"
											class="dynvibeSelect"
											name="dynvibeNewAuthorYob"
											v-model="profile.profile_yob"
										>
											<option value="unknown">Unknown</option>
											<option v-for="(yob, index) in currentYear - 1934" :key="index" :value="currentYear - yob - 4">
												{{ currentYear - yob - 4 }}
											</option>
										</select>
									</div>
								</div>
								<div class="row dynvibeModalRowForm">
									<div class="col-lg-2">
										<label for="dynvibeNewAuthorLanguage">Language *</label>
									</div>
									<div class="col-lg-10">
										<select
											id="dynvibeNewAuthorLanguage"
											class="dynvibeSelect"
											name="dynvibeNewAuthorLanguage"
											v-model="profile.profile_language"
										>
											<option v-for="val in languageslist" :key="val.id" :value="val.id">
												{{ val.value }}
											</option>
										</select>
									</div>
								</div>
								<div class="row dynvibeModalRowForm">
									<div class="col-lg-2">
										<label for="dynvibeNewAuthorCountry">Country *</label>
									</div>
									<div class="col-lg-10">
										<select
											id="dynvibeNewAuthorCountry"
											class="dynvibeSelect"
											name="dynvibeNewAuthorCountry"
											v-model="profile.profile_country"
										>
											<option v-for="val in countrieslist" :key="val.id" :value="val.id">
												{{ val.value }}
											</option>
										</select>
									</div>
								</div>
								<div class="row dynvibeModalRowForm">
									<div class="col-lg-2">
										<label for="dynvibeNewAuthorLocation">Location</label>
									</div>
									<div class="col-lg-10">
										<input
											id="dynvibeNewAuthorLocation"
											class="dynvibeInputText"
											name="dynvibeNewAuthorLocation"
											type="text"
											v-model="profile.profile_location"
										/>
									</div>
								</div>
								<div class="row dynvibeModalRowForm">
									<div class="col-lg-2">
										<label for="dynvibeNewAuthorRegion">Region</label>
									</div>
									<div class="col-lg-10">
										<input
											id="dynvibeNewAuthorRegion"
											class="dynvibeInputText"
											name="dynvibeNewAuthorRegion"
											type="text"
											v-model="profile.profile_region"
										/>
									</div>
								</div>
								<hr />
								<div class="row dynvibeModalRowForm">
									<div id="dynvibeNewAuthorInfoTwitter" class="col-lg-12">
										<div class="col-lg-12">
											<label>Twitter</label>
										</div>
										<div class="col-lg-2">
											<img
												:key="key"
												v-if="sources.twitter.profile_pic != ''"
												class="img-responsive dynvibeNewAuthorPicture"
												:src="sources.twitter.profile_pic"
												style="width: 120px; height: 90px"
											/>
											<img
												v-else
												class="img-responsive dynvibeNewAuthorPicture"
												src="/panel/picto_person-black.png"
												style="width: 120px; height: 90px"
											/>
										</div>
										<div class="col-lg-10">
											<p>
												<span class="dynvibeNewAuthorUsername">{{ sources.twitter.username }}</span>
											</p>
											<p>
												<span class="dynvibeNewAuthorGuid">{{ sources.twitter.guid }}</span>
											</p>

											<p>
												<span class="dynvibeNewAuthorBio">{{ sources.twitter.bio }}</span>
											</p>
											<p>
												<span class="dynvibeNewAuthorFollowers">{{ sources.twitter.followers }}</span>
											</p>
										</div>
									</div>
								</div>
								<div class="row dynvibeModalRowForm">
									<div id="dynvibeNewAuthorInfoInstagram" class="col-lg-12">
										<div class="col-lg-12">
											<label>Instagram</label>
										</div>
										<div class="col-lg-2">
											<img
												:key="key"
												v-if="sources.instagram.profile_pic != ''"
												class="img-responsive dynvibeNewAuthorPicture"
												:src="sources.instagram.profile_pic"
												style="width: 120px; height: 90px"
											/>
											<img
												v-else
												class="img-responsive dynvibeNewAuthorPicture"
												src="/img/panel/picto_person-black.png"
												style="width: 120px; height: 90px"
											/>
										</div>
										<div class="col-lg-10">
											<p>
												<span class="dynvibeNewAuthorUsername">{{ sources.instagram.username }}</span>
											</p>
											<p>
												<span class="dynvibeNewAuthorGuid">{{ sources.instagram.guid }}</span>
											</p>
											<p>
												<span class="dynvibeNewAuthorBio">{{ sources.instagram.bio }}</span>
											</p>
											<p>
												<span class="dynvibeNewAuthorFollowers">{{ sources.instagram.followers }}</span>
											</p>
										</div>
									</div>
								</div>
								<div class="row dynvibeModalRowForm">
									<div id="dynvibeNewAuthorInfoYoutube" class="col-lg-12">
										<div class="col-lg-12">
											<label>Youtube</label>
										</div>
										<div class="col-lg-2">
											<img
												:key="key"
												v-if="sources.youtube.profile_pic != ''"
												class="img-responsive dynvibeNewAuthorPicture"
												:src="sources.youtube.profile_pic"
												style="width: 120px; height: 90px"
											/>
											<img
												v-else
												class="img-responsive dynvibeNewAuthorPicture"
												src="/img/panel/picto_person-black.png"
												style="width: 120px; height: 90px"
											/>
										</div>
										<div class="col-lg-10">
											<p>
												<span class="dynvibeNewAuthorUsername">{{ sources.youtube.username }}</span>
											</p>
											<p>
												<span class="dynvibeNewAuthorGuid">{{ sources.youtube.guid }}</span>
											</p>
											<p>
												<span class="dynvibeNewAuthorBio">{{ sources.youtube.description }}</span>
											</p>
											<p>
												<span class="dynvibeNewAuthorFollowers">{{ sources.youtube.followers }}</span>
											</p>
										</div>
									</div>
								</div>
								<div class="row dynvibeModalRowForm">
									<div id="dynvibeNewAuthorInfoPinterest" class="col-lg-12">
										<div class="col-lg-12">
											<label>Pinterest</label>
										</div>
										<div class="col-lg-2">
											<img
												:key="key"
												v-if="sources.pinterest.profile_pic != ''"
												class="img-responsive dynvibeNewAuthorPicture"
												:src="sources.pinterest.profile_pic"
												style="width: 120px; height: 90px"
											/>
											<img
												v-else
												class="img-responsive dynvibeNewAuthorPicture"
												src="/img/panel/picto_person-black.png"
												style="width: 120px; height: 90px"
											/>
										</div>
										<div class="col-lg-10">
											<p>
												<span class="dynvibeNewAuthorUsername">{{ sources.pinterest.username }}</span>
												<span class="dynvibeNewAuthorGuid">{{ sources.pinterest.guid }}</span>
											</p>
											<p>
												<span class="dynvibeNewAuthorBio">{{ sources.pinterest.description }}</span>
											</p>
											<p>
												<span class="dynvibeNewAuthorFollowers">{{ sources.pinterest.followers }}</span>
											</p>
										</div>
									</div>
								</div>
								<div class="row dynvibeModalRowForm dynvibeCheck" style="display: none">
									<div class="col-lg-12">
										<label>Possible existing accounts to link with this account</label>
									</div>
									<div class="col-lg-4">
										<select id="dynvibePossibleAccounts" multiple class="form-control"></select>
									</div>
								</div>
								<hr />
								<div class="row dynvibeModalRowForm">
									<div>
										<div class="col-lg-12">
											<label>Segments</label>
										</div>
										<div class="col-lg-12" style="margin-bottom: 10px">
											<input
												id="dynvibeNewSegment"
												class="dynvibeInputText"
												name="dynvibeNewSegment"
												placeholder="New Segment"
												type="text"
												v-model="newsegment"
											/>
											<span
												class="dynvibeButtonIcon dynvibeAddNewSegment fas fa-plus-square"
												@click="addSegmentToProfile(newsegment)"
											></span>
										</div>
										<div class="Segment-list">
											<label
												v-for="(val, key) in profileSegments"
												class="col-lg-6 dynvibeNewPanelSegment"
												:key="'dynvibeSegment-' + key"
											>
												<input
													:id="'dynvibeSegment-' + key"
													class="dynvibeInputCheckbox dynvibeNewPanelSegment"
													:name="'dynvibeSegment-' + key"
													type="checkbox"
													v-model="profile.profile_segments"
													:value="val.label"
													:checked="profile.profile_segments.includes(val.label)"
												/>
												<span style="padding-left: 10px">{{ val.label }}</span>
											</label>
										</div>
									</div>
								</div>
							</div>

							<div class="modal-footer">
								<button
									v-if="profile.profile_id != ''"
									class="btn-success dynvibeModalFooterBtn dynvibeModalFooterBtnApply"
									@click="saveProfile(true)"
								>
									Apply
								</button>
								<button
									v-else
									class="btn-success dynvibeModalFooterBtn dynvibeModalFooterBtnApply"
									@click="saveProfile(false)"
								>
									Apply
								</button>
								<button
									class="btn-danger dynvibeModalFooterBtn dynvibeModalFooterBtnClose"
									@click="
										showModal = false;
										idprofile = '';
									"
								>
									Cancel
								</button>
							</div>
						</div>
					</div>
				</div>
			</div>
			<!-- </transition> -->
			<!-- </teleport> -->
		</div>
		<confirm ref="confirm" :color="confirmColor" :title="confirmTitle" :type="confirmType">
			<template v-slot:confirm-body>{{ confirmMessage }}</template>
		</confirm>
	</div>
</template>

<script>
import confirm from "@/components/globalVue/Confirm.vue";

export default {
	name: "profilesedit",
	props: {},
	components: {
		confirm: confirm,
	},
	data() {
		return {
			authorAgeList: [
				{ id: "unknown", value: "unknown" },
				{ id: "5", value: "< 8" },
				{ id: "10", value: "8-12" },
				{ id: "15", value: "13-17" },
				{ id: "20", value: "18-22" },
				{ id: "25", value: "23-27" },
				{ id: "30", value: "28-32" },
				{ id: "35", value: "33-37" },
				{ id: "40", value: "38-42" },
				{ id: "45", value: "43-47" },
				{ id: "50", value: "48-52" },
				{ id: "55", value: "53-57" },
				{ id: "60", value: "58-62" },
				{ id: "65", value: "63-67" },
				{ id: "70", value: "> 67" },
			],
			idprofile: "",
			modalTitle: "Edit Profile",
			showModal: false,
			profileDetails: [],
			profileSegments: [],
			currentYear: new Date().getFullYear(),
			newsegment: "",
			sources: {},
			profile: {},
			confirmColor: "",
			confirmTitle: "",
			confirmType: "",
			confirmMessage: "",
			key: 0,
		};
	},
	mounted: function () {},
	methods: {
		loadComponent() {},
		treatResponse(response) {
			this.profileSegments = response.data.segments;
			this.modalTitle = "Edit profile";
			this.resetProfile();

			this.profile.profile_id = this.idprofile;

			this.profile.profile_name = response.data.profile.profile_name;
			this.profile.profile_bio = response.data.profile.source[0].bio;
			this.profile.profile_gender = response.data.profile.profile_gender;
			this.profile.profile_age = this.currentYear - response.data.profile.profile_yob;
			this.profile.profile_yob = response.data.profile.profile_yob;
			this.profile.profile_language = response.data.profile.profile_language;
			this.profile.profile_country = response.data.profile.profile_country;
			this.profile.profile_location = response.data.profile.profile_location;
			this.profile.profile_region = response.data.profile.profile_region;

			this.profile.profile_segments =
				typeof response.data.profile.profile_segments !== "undefined" ? response.data.profile.profile_segments : [];

			this.populateSource(response.data.profile.source);
			delete response.data;
		},
		resetProfile() {
			this.profile = {
				profile_name: "",
				profile_bio: "",
				profile_gender: "unknown",
				profile_age: "unknown",
				profile_yob: "unknown",
				profile_language: "unknown",
				profile_country: "",
				profile_location: "",
				profile_region: "",
				profile_segments: [],
				profile_id: "",
			};
			this.sources = {
				twitter: {
					username: "",
				},
				instagram: {
					username: "",
				},
				pinterest: {
					username: "",
				},
				youtube: {
					username: "",
				},
			};
		},
		loadData(idprofile, showModal) {
			this.resetProfile();
			this.idprofile = idprofile;
			this.showModal = showModal;
			this.getData("getProfile", { idprofile: this.idprofile });
		},
		addNewAuthor() {
			this.resetProfile();
			this.modalTitle = "Add new author";
			this.showModal = true;

			this.$axios.get(this.$backendUrl + "getProfile").then((response) => {
				this.profileSegments = response.data.segments;
			});
		},
		populateSource(source) {
			for (let i = 0; i < source.length; i++) {
				source[i]["media"] === "twitter" ? (this.sources.twitter = source[i]) : false;
				source[i]["media"] === "instagram" ? (this.sources.instagram = source[i]) : false;
				source[i]["media"] === "pinterest" ? (this.sources.pinterest = source[i]) : false;
				source[i]["media"] === "youtube" ? (this.sources.youtube = source[i]) : false;
			}
			this.key++;
		},
		capitalize(s) {
			return s.charAt(0).toUpperCase() + s.slice(1);
		},
		getImgUrl(pic) {
			return pic;
		},
		apiProfile(provider, username) {
			if (provider === "youtube") {
				username = this.cleanSource(username, false);
			} else {
				username = this.cleanSource(username);
			}

			if (username !== "") {
				document.getElementById("dynvibeNewAuthor" + this.capitalize(provider)).parentNode.children[1].classList.add("rotate");

				this.$axios
					.get(this.$backendUrl + "apiProfile", {
						params: { provider: provider, username: username },
						paramsSerializer: function (params) {
							return this.$Qs.stringify(params, {
								arrayFormat: "brackets",
							});
						},
					})
					.then((response) => {
						document
							.getElementById("dynvibeNewAuthor" + this.capitalize(provider))
							.parentNode.children[1].classList.remove("rotate");

						if (response.data.user && response.data.error.length == 0) {
							if (!username) {
								document.getElementById("dynvibeNewAuthor" + this.capitalize(provider)).classList.remove("providerFound");
								document.getElementById("dynvibeNewAuthor" + this.capitalize(provider)).classList.add("providerNotFound");

								provider === "twitter"
									? (this.sources.twitter = {
											username: username,
									  })
									: false;
								provider === "instagram"
									? (this.sources.instagram = {
											username: username,
									  })
									: false;
								provider === "pinterest"
									? (this.sources.pinterest = {
											username: username,
									  })
									: false;
								provider === "youtube"
									? (this.sources.youtube = {
											username: username,
									  })
									: false;
							} else {
								this.majSources(provider, response.data.user);
							}
						} else {
							this.confirmErrorModal(response.data.error);
							document.getElementById("dynvibeNewAuthor" + this.capitalize(provider)).classList.add("providerNotFound");

							return false;
						}
					})
					.catch((error) => {
						document
							.getElementById("dynvibeNewAuthor" + this.capitalize(provider))
							.parentNode.children[1].classList.remove("rotate");
						document.getElementById("dynvibeNewAuthor" + this.capitalize(provider)).classList.add("providerNotFound");
						this.confirmErrorModal(error);
					});
			} else {
				this.sources[provider] = {
					username: "",
				};
			}
			// this.key++;
		},
		majSources(provider, response) {
			document.getElementById("dynvibeNewAuthor" + this.capitalize(provider)).classList.remove("providerNotFound");
			document.getElementById("dynvibeNewAuthor" + this.capitalize(provider)).classList.add("providerFound");

			if (provider === "twitter") {
				this.sources.twitter.username = response.screen_name.toLowerCase();
				this.sources.twitter.name = response.name;
				this.sources.twitter.guid = response.id_str;
				this.sources.twitter.profile_pic = response.profile_image_url_https;
				this.sources.twitter.bio = response.description;
				this.sources.twitter.followers = parseInt(response.followers_count);

				response.gender === true ? (this.profile.profile_gender = response.profile_gender) : false;
				response.lang === true ? (this.profile.profile_language = response.profile_lang) : false;
				response.country === true ? (this.profile.profile_country = response.profile_country) : false;
				response.location === true ? (this.profile.profile_location = response.profile_location) : false;

				this.profile.profile_bio = this.sources.twitter.bio;
				this.profile.profile_name = this.sources.twitter.name;
			} else if (provider === "instagram") {
				this.sources.instagram.guid = response.guid;
				this.sources.instagram.name = response.name;
				this.sources.instagram.username = response.username.toLowerCase();
				this.sources.instagram.profile_pic = response.profile_pic;
				this.sources.instagram.bio = response.bio;
				this.sources.instagram.followers = response.followers_count;

				this.profile.profile_bio = this.sources.instagram.bio;
				this.profile.profile_name = this.sources.instagram.name;
			} else if (provider === "youtube") {
				this.sources.youtube.username = response.items[0].snippet.title.toLowerCase();
				this.sources.youtube.name = response.items[0].snippet.title;
				this.sources.youtube.guid = response.items[0].snippet.id;
				if (response.items[0].snippet.thumbnails.high.url)
					this.sources.youtube.profile_pic = response.items[0].snippet.thumbnails.high.url;
				this.sources.youtube.description = response.items[0].snippet.description;
				this.sources.youtube.followers = parseInt(response.items[0].statistics.viewCount);
				if (response.items[0].snippet.gender) this.sources.youtube.gender = response.items[0].snippet.gender;

				this.profile.profile_bio = this.sources.youtube.description;
				this.profile.profile_name = this.sources.youtube.name;
			} else if (provider === "pinterest") {
				this.sources.pinterest.username = response.resource_response.data.username.toLowerCase();
				this.sources.pinterest.name = response.resource_response.data.full_name;
				this.sources.pinterest.guid = response.resource_response.data.id;
				this.sources.pinterest.username = response.resource_response.data.username;
				if (response.resource_response.data.image_xlarge_url)
					this.sources.pinterest.profile_pic = response.resource_response.data.image_xlarge_url;
				this.sources.pinterest.description = response.resource_response.data.about;
				this.sources.pinterest.followers = parseInt(response.resource_response.data.follower_count);
				if (response.resource_response.data.gender) this.sources.pinterest.gender = response.resource_response.data.gender;

				this.profile.profile_bio = this.sources.pinterest.description;
				this.profile.profile_name = this.sources.pinterest.name;
			}
			// this.key++;
		},
		changeAuthorAge(e) {
			this.profile.profile_yob = this.currentYear - e.target.value;
		},
		addSegmentToProfile(segment) {
			if (segment.trim() !== "") {
				this.$axios
					.post(
						this.$backendUrl + "segments",
						this.$Qs.stringify({
							label: segment,
							target: "segment",
							action: "add",
						})
					)
					.then((response) => {
						if (response.data.isOk) {
							this.profileSegments.push({ label: segment });
							this.profile.profile_segments.push(segment);
						} else {
							this.confirmErrorModal("This segment already exist.");
							return false;
						}
					})
					.catch((error) => {
						this.confirmErrorModal(error);
					});
			}
		},
		saveProfileVerification() {
			// Emoji
			let regexEmoji =
				/(?:[\u2700-\u27bf]|(?:\ud83c[\udde6-\uddff]){2}|[\ud800-\udbff][\udc00-\udfff]|[\u0023-\u0039]\ufe0f?\u20e3|\u3299|\u3297|\u303d|\u3030|\u24c2|\ud83c[\udd70-\udd71]|\ud83c[\udd7e-\udd7f]|\ud83c\udd8e|\ud83c[\udd91-\udd9a]|\ud83c[\udde6-\uddff]|[\ud83c[\ude01\uddff]|\ud83c[\ude01-\ude02]|\ud83c\ude1a|\ud83c\ude2f|[\ud83c[\ude32\ude02]|\ud83c\ude1a|\ud83c\ude2f|\ud83c[\ude32-\ude3a]|[\ud83c[\ude50\ude3a]|\ud83c[\ude50-\ude51]|\u203c|\u2049|[\u25aa-\u25ab]|\u25b6|\u25c0|[\u25fb-\u25fe]|\u00a9|\u00ae|\u2122|\u2139|\ud83c\udc04|[\u2600-\u26FF]|\u2b05|\u2b06|\u2b07|\u2b1b|\u2b1c|\u2b50|\u2b55|\u231a|\u231b|\u2328|\u23cf|[\u23e9-\u23f3]|[\u23f8-\u23fa]|\ud83c\udccf|\u2934|\u2935|[\u2190-\u21ff])/;
			let regexLetters = /[a-zA-Z0-9]{1,}/;
			let filtername = this.profile.profile_name;
			let filternameRegexEmoji = regexEmoji.test(filtername);
			let filternameRegexLetters = regexLetters.test(filtername);
			let status = true;

			if (filternameRegexEmoji === true || filternameRegexLetters === false) {
				document.getElementById("dynvibeNewAuthorName").classList.add("dynvibeInputError");
				status = false;
			} else {
				document.getElementById("dynvibeNewAuthorName").classList.remove("dynvibeInputError");
			}
			if (this.profile.profile_gender === "unknown") {
				document.getElementById("dynvibeNewAuthorGender").classList.add("dynvibeInputError");
				status = false;
			} else {
				document.getElementById("dynvibeNewAuthorGender").classList.remove("dynvibeInputError");
			}
			if (this.profile.profile_yob === "unknown" || this.profile.profile_yob === "0") {
				document.getElementById("dynvibeNewAuthorYob").classList.add("dynvibeInputError");
				status = false;
			} else {
				document.getElementById("dynvibeNewAuthorYob").classList.remove("dynvibeInputError");
			}
			if (this.profile.profile_language === "unknown") {
				document.getElementById("dynvibeNewAuthorLanguage").classList.add("dynvibeInputError");
				status = false;
			} else {
				document.getElementById("dynvibeNewAuthorLanguage").classList.remove("dynvibeInputError");
			}
			if (this.profile.profile_country === "") {
				document.getElementById("dynvibeNewAuthorCountry").classList.add("dynvibeInputError");
				status = false;
			} else {
				document.getElementById("dynvibeNewAuthorCountry").classList.remove("dynvibeInputError");
			}
			if (this.profile.profile_segments.length === 0) {
				for (let i = 0; i < document.getElementsByClassName("dynvibeNewPanelSegment").length; i++) {
					document.getElementsByClassName("dynvibeNewPanelSegment")[i].classList.add("dynvibeInputError");
				}
				status = false;
			} else {
				for (let i = 0; i < document.getElementsByClassName("dynvibeNewPanelSegment").length; i++) {
					document.getElementsByClassName("dynvibeNewPanelSegment")[i].classList.remove("dynvibeInputError");
				}
			}

			if (
				status === true &&
				(this.$data.sources.twitter.guid ||
					this.$data.sources.instagram.guid ||
					this.$data.sources.youtube.guid ||
					this.$data.sources.pinterest.guid)
			) {
				return true;
			} else {
				document.getElementById("profiles-edit-body").scrollTo(0, 0);
				return false;
			}
		},
		saveProfile(e) {
			if (this.saveProfileVerification() === false) {
				return false;
			}

			this.showModal = false;
			this.confirmLoadingModal("open");

			let url = e === true ? this.$backendUrl + "modifyAuthor" : this.$backendUrl + "addAuthor";

			let sources = {
				twitter: [],
				instagram: [],
				youtube: [],
				pinterest: [],
			};
			this.$data.sources.twitter.guid && this.$data.sources.twitter.username
				? (sources["twitter"] = this.$data.sources.twitter)
				: false;
			this.$data.sources.instagram.guid && this.$data.sources.instagram.username
				? (sources["instagram"] = this.$data.sources.instagram)
				: false;
			this.$data.sources.youtube.guid && this.$data.sources.youtube.username
				? (sources["youtube"] = this.$data.sources.youtube)
				: false;
			this.$data.sources.pinterest.guid && this.$data.sources.pinterest.username
				? (sources["pinterest"] = this.$data.sources.pinterest)
				: false;

			this.$axios
				.post(
					url,
					this.$Qs.stringify({
						profile: this.$data.profile,
						sources: sources,
					})
				)
				.then((response) => {
					this.profile = {};

					if (response.data.error === "alreadyExists") {
						this.confirmErrorModal("Author already exists.");
					} else if (response.data.error === "APINoResponse") {
						this.confirmErrorModal("No response from API.");
					} else {
						if (e === true) {
							response.data.error
								? this.confirmErrorModal("Author update failed.")
								: this.confirmSuccessModal("Author updated!");
						} else {
							response.data.error
								? this.confirmErrorModal("Author adding failed.")
								: this.confirmSuccessModal("Author added!");
						}
						this.$emit("reloadlist");
					}
				})
				.catch(() => {
					this.confirmErrorModal("Author update failed.");
				});
		},
		cleanSource(val, doLowerCase = true) {
			val = val.replace("http://instagram.com/", "");
			val = val.replace("https://instagram.com/", "");
			val = val.replace("https://www.instagram.com/", "");
			val = val.replace("instagram.com/", "");
			val = val.replace("http://twitter.com/", "");
			val = val.replace("https://twitter.com/", "");
			val = val.replace("http://youtube.com/channel/", "");
			val = val.replace("https://youtube.com/channel/", "");
			val = val.replace("http://www.youtube.com/channel/", "");
			val = val.replace("https://www.youtube.com/channel/", "");
			val = val.replace("www.youtube.com/channel/", "");
			val = val.replace("youtube.com/channel/", "");
			val = val.replace("http://youtube.com/user/", "");
			val = val.replace("https://youtube.com/user/", "");
			val = val.replace("http://www.youtube.com/user/", "");
			val = val.replace("https://www.youtube.com/user/", "");
			val = val.replace("www.youtube.com/user/", "");
			val = val.replace("youtube.com/user/", "");
			val = val.replace("instagram.com/", "");
			val = val.replace("nl.pinterest.com/", "");
			val = val.replace("pinterest.com/", "");
			val = val.replace("pinterest.fr/", "");
			val = val.replace("https://", "");
			val = val.replace("http://", "");
			val = val.replace("https://www.", "");
			val = val.replace("http://www.", "");
			val = val.replace("www.", "");
			val = val.replace("/", "");
			val = val.replace(" ", "");
			val = val.replace("_created", "");
			val = val.replace("https://www.pinterest.fr/", "");
			if (doLowerCase) {
				val = val.toLowerCase();
			}
			val = val.replace("/", "");
			return val;
		},
	},
	watch: {
		showModal: function () {
			if (this.showModal === false) {
				this.resetProfile();
			}
		},
	},
};
</script>

<style>
.modal-mask {
	position: fixed;
	z-index: 9998;
	top: 0;
	left: 0;
	width: 100%;
	height: 100%;
	background-color: rgba(0, 0, 0, 0.5);
	display: table;
	transition: opacity 0.3s ease;
}

.modal-wrapper {
	display: table-cell;
	vertical-align: middle;
}

.close {
	outline: 0;
}

#dynvibeNewAuthorGroupNumberKids,
#dynvibeNewAuthorGroupNumberPets,
#dynvibeNewAuthorGroupNumberCars {
	display: none;
}

#dynvibeNewAuthorGroupNumberKids.active,
#dynvibeNewAuthorGroupNumberPets.active,
#dynvibeNewAuthorGroupNumberCars.active {
	display: block;
}

#dynvibeNewAuthorGroupItemskids,
#dynvibeNewAuthorGroupItemsPets,
#dynvibeNewAuthorGroupItemsCars {
	display: none;
}

#dynvibeNewAuthorGroupItemskids.active,
#dynvibeNewAuthorGroupItemsPets.active,
#dynvibeNewAuthorGroupItemsCars.active {
	display: block;
}

input.providerFound {
	border-color: #2eef2b;
	color: #2eef2b;
}

input.providerNotFound {
	border-color: #ef402e;
	color: #ef402e;
}

.dynvibeButtonIcon {
	margin-left: 0;
}

.dynvibeNewAuthorRefreshSource.rotate {
	position: absolute;
	margin-left: 4px;
	-webkit-animation: spin 4s linear infinite;
	-moz-animation: spin 4s linear infinite;
	animation: spin 4s linear infinite;
}

@-moz-keyframes spin {
	100% {
		-moz-transform: rotate(360deg);
	}
}

@-webkit-keyframes spin {
	100% {
		-webkit-transform: rotate(360deg);
	}
}

@keyframes spin {
	100% {
		-webkit-transform: rotate(360deg);
		transform: rotate(360deg);
	}
}
</style>
